import styled from 'styled-components';

import { ContentBox } from '~/src/components/ContentBox';

export const StyledContentBox = styled(ContentBox)`
  > * + * {
    margin-top: 24px;
  }
`;
